export type TMetric = {
    name: string;
    values: string[];
};


export const metrics = [
    {
        name: "Common",
        values: [
            "Annual Revenue",
            "Annual Costs",
            "Annual Profit",
            "Monthly Burn Rate",
            "MRR",
            "ARR",
            "Churn Rate",
            "LTV",
            "CAC"
        ]
    },
    {
        name: "Freemium",
        values: [
            "Conversion Rate",
            "DAU",
            "MAU",
            "ARPU",
            "CAC",
            "Conversion Rate (Free to Paid)",
            "Active User Growth",
            "DAU (Daily Active Users)",
            "MAU (Monthly Active Users)",
            "ARPU (Average Revenue Per User)"
        ]
    },
    {
        name: "E-Commerce DTC",
        values: [
            "AOV",
            "Conversion Rate",
            "Customer Lifetime Value",
            "Cart Abandonment Rate",
            "Customer Acquisition Cost"
        ]
    },
    {
        name: "E-Commerce Retail",
        values: [
            "Gross Merchandise Volume",
            "Average Order Value",
            "Customer Lifetime Value",
            "Return on Ad Spend",
            "Inventory Turnover Rate"
        ]
    },
    {
        name: "Advertising",
        values: [
            "CPM",
            "CPC",
            "CTR",
            "ROAS",
            "CPA"
        ]
    },
    {
        name: "Marketplace",
        values: [
            "GMV (Gross Merchandise Volume)",
            "Take Rate (Commission Rate)",
            "Average Order Value (AOV)",
            "Buyer-Seller Ratio",
            "Repeat Purchase Rate"
        ]
    },
    {
        name: "SaaS (Software as a Service)",
        values: [
            "MRR",
            "ARR",
            "Churn Rate",
            "Customer Lifetime Value (LTV)",
            "Customer Acquisition Cost (CAC)"
        ]
    },
    {
        name: "On Demand",
        values: [
            "Gross Booking Value",
            "Customer Lifetime Value (LTV)",
            "Customer Acquisition Cost (CAC)",
            "Utilization Rate",
            "Service Completion Rate"
        ]
    },
    {
        name: "Affiliate Marketing",
        values: [
            "CPA (Cost Per Acquisition)",
            "Revenue Share",
            "Click-Through Rate (CTR)",
            "Conversion Rate",
            "Average Order Value (AOV)"
        ]
    },
    {
        name: "Licensing",
        values: [
            "Royalty Rate",
            "Revenue Growth Rate",
            "Operating Margin",
            "Sales per License",
            "Market Penetration Rate"
        ]
    },
    {
        name: "Franchise",
        values: [
            "Royalty Fees",
            "Average Unit Volume (AUV)",
            "Operating Margin",
            "Break-Even Point",
            "Franchise Growth Rate"
        ]
    },
    {
        name: "Direct Sales",
        values: [
            "Sales Volume",
            "Conversion Rate",
            "Customer Retention Rate",
            "Average Revenue Per Salesperson",
            "Sales Cycle Length"
        ]
    },
    {
        name: "Dropshipping",
        values: [
            "Gross Margin",
            "Order Fulfillment Rate",
            "Return Rate",
            "Supplier Performance Score",
            "Average Order Value (AOV)"
        ]
    },
    {
        name: "B2B",
        values: [
            "Sales Conversion Rate",
            "Customer Retention Rate",
            "Average Contract Value (ACV)",
            "Sales Cycle Length",
            "LTV (Lifetime Value)"
        ]
    },
    {
        name: "B2C",
        values: [
            "Average Order Value (AOV)",
            "Customer Acquisition Cost (CAC)",
            "Conversion Rate",
            "Net Promoter Score (NPS)",
            "Churn Rate"
        ]
    },
    {
        name: "B2G",
        values: [
            "Contract Value",
            "Bid Win Rate",
            "Contract Renewal Rate",
            "Procurement Cycle Time",
            "Compliance Rate"
        ]
    },
    {
        name: "Crowdsourcing",
        values: [
            "Participation Rate",
            "Project Completion Rate",
            "Average Contribution Value",
            "User Retention Rate",
            "Quality of Contributions"
        ]
    },
    {
        name: "Pay-Per-Use",
        values: [
            "Average Revenue Per User (ARPU)",
            "Usage Frequency",
            "Customer Retention Rate",
            "Service Utilization Rate",
            "Customer Acquisition Cost (CAC)"
        ]
    },
    {
        name: "Data Monetization",
        values: [
            "Data Sales Revenue",
            "Data Acquisition Cost",
            "Number of Data Transactions",
            "Data Quality Score",
            "Data Usage Frequency"
        ]
    },
    {
        name: "Razor and Blades",
        values: [
            "Repeat Purchase Rate of Consumables",
            "Customer Retention Rate",
            "Gross Margin on Consumables",
            "Initial Product Penetration Rate",
            "Customer Lifetime Value (LTV)"
        ]
    },
    {
        name: "Transaction Fee",
        values: [
            "Total Transaction Volume",
            "Average Transaction Size",
            "Fee Revenue",
            "Number of Active Users",
            "Transaction Completion Rate"
        ]
    }
];
